export default class NetworkError extends Error {
  // Set when the request ran out of time, so error reporting can tell a timeout from other failures.
  // Optional so the class stays structurally compatible with a plain `Error`.
  readonly isTimeout?: boolean;

  constructor(public message: string, isTimeout?: boolean) {
    super(message);
    this.name = 'NetworkError';
    this.isTimeout = isTimeout;
    // Set the prototype explicitly, see https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    // extending classes will also need to do this
    Object.setPrototypeOf(this, NetworkError.prototype);
  }
}
